// src/components/aols/aeo/OLSCalendarTime/LightTime.tsx
import React from "react";
import { Table, Typography } from "antd";
import styled from "styled-components";
import MiniLightTimeToggle from "./MiniLightTimeToggle";

const { Text } = Typography;

// Styled components for the LightTime component
const LightTimeWrapper = styled.div`
  margin: 20px 0;
  text-align: center;
`;

const Description = styled(Text)`
  color: #ffcc00;
  font-size: 16px;
  margin-bottom: 20px;
  display: block;
`;

const StyledTable = styled(Table)`
  .ant-table-thead > tr > th {
    background: #222 !important;
    color: #ffcc00 !important;
    text-align: center !important;
  }
  .ant-table-tbody > tr > td {
    background: #333 !important;
    color: #ffffff !important;
    text-align: center !important;
  }
  .ant-table-tbody > tr:nth-child(odd) > td {
    background: #444 !important;
  }
  .ant-table-tbody > tr:hover > td:nth-child(1),
  .ant-table-tbody > tr:hover > td:nth-child(2) {
    background: rgba(255, 255, 255, 0.5) !important;
  }
`;

// Time data (still needed for the table)
const timeData = [
  { old12: "12:00AM", old24: "00:00", lightTime: "7dh" },
  { old12: "1:00AM", old24: "1:00", lightTime: "8dh" },
  { old12: "2:00AM", old24: "2:00", lightTime: "9dh" },
  { old12: "3:00AM", old24: "3:00", lightTime: "10dh" },
  { old12: "4:00AM", old24: "4:00", lightTime: "11dh" },
  { old12: "5:00AM", old24: "5:00", lightTime: "12dh" },
  { old12: "6:00AM", old24: "6:00", lightTime: "1LH" },
  { old12: "7:00AM", old24: "7:00", lightTime: "2LH" },
  { old12: "8:00AM", old24: "8:00", lightTime: "3LH" },
  { old12: "9:00AM", old24: "9:00", lightTime: "4LH" },
  { old12: "10:00AM", old24: "10:00", lightTime: "5LH" },
  { old12: "11:00AM", old24: "11:00", lightTime: "6LH" },
  { old12: "12:00PM", old24: "12:00", lightTime: "7LH" },
  { old12: "1:00PM", old24: "13:00", lightTime: "8LH" },
  { old12: "2:00PM", old24: "14:00", lightTime: "9LH" },
  { old12: "3:00PM", old24: "15:00", lightTime: "10LH" },
  { old12: "4:00PM", old24: "16:00", lightTime: "11LH" },
  { old12: "5:00PM", old24: "17:00", lightTime: "12LH" },
  { old12: "6:00PM", old24: "18:00", lightTime: "1dh" },
  { old12: "7:00PM", old24: "19:00", lightTime: "2dh" },
  { old12: "8:00PM", old24: "20:00", lightTime: "3dh" },
  { old12: "9:00PM", old24: "21:00", lightTime: "4dh" },
  { old12: "10:00PM", old24: "22:00", lightTime: "5dh" },
  { old12: "11:00PM", old24: "23:00", lightTime: "6dh" },
];

const LightTime: React.FC = () => {
  const columns = [
    {
      title: "12-Hour Clock",
      dataIndex: "old12",
      key: "old12",
      width: "33%",
    },
    {
      title: "24-Hour Clock",
      dataIndex: "old24",
      key: "old24",
      width: "33%",
    },
    {
      title: "Correct Light Time",
      dataIndex: "lightTime",
      key: "lightTime",
      width: "33%",
      render: (text: string, record: any) => {
        const isDh = text.endsWith("dh");
        const isLh = text.endsWith("LH");

        const backgroundColor = isDh ? "#000000" : isLh ? "#ffffff" : undefined;

        return (
          <span
            data-time={text}
            style={{
              backgroundColor,
              color: isDh ? "#ffffff" : isLh ? "#0427f4" : undefined,
              display: "block",
              padding: "4px",
            }}
          >
            {text}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <MiniLightTimeToggle />
      <LightTimeWrapper>
        <Description>Q2 Season Time Conversion into Correct Time Measurement</Description>
        <StyledTable
          dataSource={timeData}
          columns={columns}
          pagination={false}
          rowKey={(record) => record.old12}
          bordered
        />
      </LightTimeWrapper>
    </>
  );
};

export default LightTime;